import api from './api';
import { IPrepaymentRow } from '../types/prepayments';

export const createPrepayment = async (year: number, month: number, prepaymentType: string, payload: IPrepaymentRow[]): Promise<void> => {
  await api.post('/prepayments', { year, month, prepaymentType, payload });
};